/* eslint-disable
    react/jsx-uses-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
module.exports = require('./views/social_share')



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/social_share/index.js